import React from 'react';
import ReactDOM from 'react-dom/client';
import {createBrowserRouter, RouterProvider} from "react-router-dom";
import './index.css';
import { I18nextProvider } from "react-i18next";
import i18next from "i18next";
import reportWebVitals from './reportWebVitals';
import LandingPage from './components/pages/landingPage/LandingPage';
import TextEditorPage from './components/pages/textEditorPage/TextEditorPage.jsx';
import LoginPage from './components/pages/loginPage/LoginPage';
import RegisterPage from './components/pages/registerPage/RegisterPage';
import HistoryPage from './components/pages/historyPage/HistoryPage';
import ProductDemo from './components/pages/productDemoPage/ProductDemoPage.jsx'
import NotFoundPage from './components/pages/notFoundPage/notFoundPage.jsx';

const router = createBrowserRouter([
  {
    path: "/",
    element: <LandingPage />
  },
  {
    path: "/history",
    element: <HistoryPage />
  },
  {
    path: "/product",
    element: <TextEditorPage />
  },
  {
    path: "/login",
    element: <LoginPage />
  },
  {
    path: "/register",
    element: <RegisterPage />
  },
  {
    path: "/product-demo",
    element: <ProductDemo />
  },
  {
    path: "*",
    element: <NotFoundPage />
  }
]);

i18next.init({
  interpolation: { escapeValue: false }, // React already does escaping
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
    <I18nextProvider i18n={i18next} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
